import {createSlice} from "@reduxjs/toolkit";

const VideoTelematicsFilterSlicer = createSlice({
    name: 'videoTelematicsFilter',
    initialState: {
        vehicles: [],
        groups: [],
        alerts: [],
    },
    reducers: {
        telematicsVehicleFilter: (state, action) => {
            if (state.vehicles.includes(action.payload)) {
                const index = state.vehicles.indexOf(action.payload);
                state.vehicles.splice(index, 1);
            } else {
                state.vehicles.push(action.payload);
            }
        },
        telematicsGroupFilter: (state, action) => {
            if (state.groups.includes(action.payload)) {
                const index = state.groups.indexOf(action.payload);
                state.groups.splice(index, 1);
            } else {
                state.groups.push(action.payload);
            }
        },
        telematicsAlertFilter: (state, action) => {
            if (state.alerts.includes(action.payload)) {
                const index = state.alerts.indexOf(action.payload);
                state.alerts.splice(index, 1);
            } else {
                state.alerts.push(action.payload);
            }
        },
    }
})

export default VideoTelematicsFilterSlicer.reducer;
export const {
    telematicsVehicleFilter,
    telematicsGroupFilter,
    telematicsAlertFilter
} = VideoTelematicsFilterSlicer.actions
